import StatusPill from '../common/StatusPill';
import { formatDate } from '../../fonctions/fonctions';
import { Globe } from 'lucide-react';

function mapWStatus(status) {
  const s = (status || '').toLowerCase();
  if (s === 'inaccessible' || s === 'hors ligne') return 'down';
  if (s === 'ralenti' || s === 'dégradé')         return 'degraded';
  if (s === 'opérationnel')                        return 'operational';
  return 'unknown';
}

function DataRow({ label, value }) {
  if (!value) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: 500 }}>{label}</span>
      <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontFamily: 'monospace', fontWeight: 600 }}>{value}</span>
    </div>
  );
}

function EndpointBlock({ label, status, statusLabel, latency, avg }) {
  return (
    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <span style={{
        fontSize: '0.63rem', fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: '0.08em',
        color: 'var(--text-muted)',
      }}>
        {label}
      </span>

      <StatusPill status={status} label={statusLabel} size="sm" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <DataRow label="Latence"  value={latency || null} />
        <DataRow label="Moyenne"  value={avg && avg !== 'N/A' ? avg : null} />
      </div>
    </div>
  );
}

function WebsiteCard({ website, onClick }) {
  const siteStatus = mapWStatus(website.website_status);
  const apiStatus  = website.api ? mapWStatus(website.api.api_status) : 'unknown';

  const borderColor = siteStatus === 'down'    ? '#fecaca'
                    : siteStatus === 'degraded' ? '#fed7aa'
                    : 'var(--border-md)';

  return (
    <div
      onClick={onClick}
      style={{
        background: 'white', border: `1px solid ${borderColor}`,
        borderRadius: 'var(--radius-lg)', padding: '1.1rem 1.25rem',
        boxShadow: 'var(--shadow-xs)', cursor: 'pointer',
        display: 'flex', flexDirection: 'column', gap: '0.85rem',
        transition: 'box-shadow 0.16s ease, transform 0.16s ease',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'var(--shadow-xs)'; e.currentTarget.style.transform = 'none'; }}
    >

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
        <span style={{
          width: 30, height: 30, borderRadius: 9, flexShrink: 0,
          background: 'var(--accent-dim)', color: 'var(--accent-light)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Globe size={14} />
        </span>
        <span style={{ fontWeight: 700, fontSize: '0.95rem', color: 'var(--text)' }}>
          {website.client_name}
        </span>
      </div>

      <div style={{ borderTop: '1px solid var(--border)' }} />

      {/* Site + API côte à côte */}
      <div style={{ display: 'flex', gap: '1.25rem' }}>

        <EndpointBlock
          label="Site web"
          status={siteStatus}
          statusLabel={website.website_status}
          latency={website.website_latency}
          avg={website.avg_latency}
        />

        <div style={{ width: 1, background: 'var(--border)', flexShrink: 0 }} />

        {website.api
          ? (
            <EndpointBlock
              label="API"
              status={apiStatus}
              statusLabel={website.api.api_status}
              latency={website.api.api_latency}
              avg={website.api.avg_latency}
            />
          )
          : (
            <div style={{ flex: 1 }}>
              <span style={{ fontSize: '0.63rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-muted)' }}>API</span>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 8 }}>Non disponible</div>
            </div>
          )
        }
      </div>

      {/* Footer */}
      <div style={{
        fontSize: '0.7rem', color: 'var(--text-muted)',
        borderTop: '1px solid var(--border)', paddingTop: '0.6rem',
        display: 'flex', justifyContent: 'space-between',
      }}>
        <span>Dernière vérification</span>
        <span style={{ fontWeight: 600, color: 'var(--text-secondary)' }}>
          {formatDate(website.website_last_update) || '—'}
        </span>
      </div>

    </div>
  );
}

export default WebsiteCard;
